import * as jQuery from 'jquery';

interface ModalParams {
  toggles: JQuery;
}

export class Modal {

  modal: JQuery;
  modalContent: JQuery;
  constructor(private elem: JQuery, params: Partial<ModalParams>) {

    this.init();

    jQuery('[data-barker-modal-content]').hide();

    params = jQuery.extend(params, { toggles: jQuery('[data-barker-modal-open]') });

    params.toggles.each(
      (index, item) => {
        jQuery(item).on('click', (e) => this.openModal(e, jQuery(item)));
      }
    );

  }

  init() {

    this.buildModal();

    this.elem.append(
      this.modal
    );

  }

  buildModal() {

    const modal = jQuery('<div class="modal"></div>');
    const modalBg = jQuery('<div class="modal-background"></div>');
    const modalClose = jQuery('<button class="modal-close"></button>');
    const modalContent = jQuery('<div class="modal-content"></div>');

    modal.append(modalBg).append(modalClose).append(modalContent);

    modalBg.on('click', (e) => this.closeModal(e));
    modalClose.on('click', (e) => this.closeModal(e));

    this.modal = modal;
    this.modalContent = modalContent;

  }

  openModal(e: JQuery.Event, item: JQuery) {

    e.preventDefault();

    const modalId = item.data('barkerModalOpen');

    const content = jQuery('[data-barker-modal-content="' + modalId + '"]');

    this.modalContent.html(content.html());

    this.modal.addClass('is-active');

  }

  closeModal(e: JQuery.Event) {

    this.modalContent.empty();
    this.modal.removeClass('is-active');

  }

}


// WEBPACK FOOTER //
// ./resources/src/components/modal/modal.tsx